import { getCurrentLanguage } from 'locale'

const LANGUAGES_WITH_DATETIME_EXTRA_SYMBOLS = ['zh-CN', 'zh-SG', 'zh-TW', 'ko', 'ja']

export const HAS_OFFSET = LANGUAGES_WITH_DATETIME_EXTRA_SYMBOLS.includes(getCurrentLanguage())

export const SCHEDULE_TYPES = {
    ALL_BATTLES: 'allBattleModes',
    ONE_BATTLE: 'oneBattleMode',
    MAIN_SCHEDULE: 'mainSchedule',
}



// WEBPACK FOOTER //
// ./containers/Schedule/constants.js